export const getIdArr = (arr?: { id: string }[] | null) => {
  if (!arr) return [];
  return arr.map(el => el.id);
};
